"use client";

import Minus from "@/components/icons/Minus";
import Plus from "@/components/icons/Plus";
import Button from "@/components/ui/Button";
import { getUserData } from "@/features/global/user_data";
import { useCart } from "@/lib/centra/hooks";
import { useAddVoucher, useRemoveVoucher } from "@frend-digital/centra/client";
import { sendGTMEvent } from "@frend-digital/events/gtm";
import clsx from "clsx";
import { useState } from "react";
import Input from "../Input";
import styles from "./vouchers.module.css";

export const Vouchers = () => {
  const { data } = useCart();
  const voucher = data?.vouchers?.at(0);

  const [newVoucher, setNewVoucher] = useState<string>("");
  const [displayVoucherInput, setDisplayVoucherInput] =
    useState<boolean>(false);

  const { mutate: removeVoucher } = useRemoveVoucher();
  const { mutate: addVoucher, error: addVoucherError } = useAddVoucher();

  if (voucher)
    return (
      <div className={clsx(styles.activeVoucher, styles.container)}>
        <span>
          <p>Add a voucher</p>
        </span>
        <span className={styles.subContainer}>
          <span className={styles.codeContainer}>
            <p className={styles.voucherLabel}>Voucher</p>
            <p className={styles.voucherCode}>{voucher.voucher}</p>
          </span>
          <Button
            onClick={() => {
              removeVoucher({
                voucher: voucher.voucher!,
              });
            }}
            className={styles.buttons}
          >
            Remove
          </Button>
        </span>
      </div>
    );

  if (displayVoucherInput) {
    return (
      <div className={styles.wrap}>
        <Button
          className={styles["add-voucher"]}
          onClick={() => {
            setDisplayVoucherInput(false);
          }}
          mode="unset"
        >
          <span>
            <span>Add a voucher</span>
            <Minus />
          </span>
        </Button>
        <form
          className={styles.form}
          onSubmit={e => {
            e.preventDefault();

            if (!newVoucher) return;

            addVoucher(
              {
                voucher: newVoucher,
              },
              {
                onSuccess: () => {
                  setDisplayVoucherInput(false);

                  const userData = getUserData();

                  sendGTMEvent({ ecommerce: null });
                  sendGTMEvent({
                    event: "voucher_code_applied",
                    ecommerce: {
                      voucher_code: newVoucher,
                    },
                    ...userData,
                  });
                },
              },
            );
          }}
        >
          <Input
            placeholder="Voucher"
            name="code"
            value={newVoucher}
            onChange={e => {
              setNewVoucher(e.target.value);
            }}
            isValid
          />
          <span className={styles.buttons}>
            <Button>Apply</Button>
          </span>
        </form>

        {addVoucherError && <p className={styles.error}>Invalid voucher</p>}
      </div>
    );
  }

  return (
    <Button
      mode="unset"
      className={styles["add-voucher"]}
      onClick={() => {
        setDisplayVoucherInput(true);
      }}
    >
      <span>
        <span>Add a voucher</span>
        <Plus />
      </span>
    </Button>
  );
};
